import { useEffect } from 'react';

const Security = () => {
  if (import.meta.env.MODE !== 'production') {
    return null;
  }
  useEffect(() => {
    // Vô hiệu hóa chuột phải
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Vô hiệu hóa F12 và các phím tắt khác
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.ctrlKey && e.shiftKey && e.key === 'J') ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
      }
    };

    // Thêm event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return null;
};

export default Security; 